import React, {FC, useContext} from "react";
import {Typography} from "@material-ui/core";
import {AccountCircleOutlined, EventOutlined, FormatListBulletedOutlined} from "@material-ui/icons";
import {MenuButton} from "./MenuButton";
import {useWorker} from "../../workers/redux/workers.hook";
import {AuthContext} from "../../../auth/components/AuthProvider";
import {Skeleton} from "@material-ui/lab";

export const WorkerWelcomeScreen: FC = () => {
    const {userId} = useContext(AuthContext);

    const {worker} = useWorker(userId);

    return (
        <div>
            <Typography
                style={{
                    marginBottom: 32,
                    marginTop: 16
                }}
                variant="h5"
                color="textSecondary"
            >
                {worker ? `Willkommen ${worker.firstName}!` : <Skeleton variant="text" width={250} height={32}/>}
            </Typography>
            <MenuButton
                label="Meine Daten"
                icon={AccountCircleOutlined}
                navigateTo={"/worker/personal-data"}
                cardProps={{style:{marginBottom: 24}}}
            />
            <MenuButton
                label="Meine Verfügbarkeiten"
                icon={EventOutlined}
                navigateTo={"/worker/calendar"}
                cardProps={{style:{marginBottom: 24}}}
            />
            <MenuButton
                label="Arbeitszeiten"
                icon={FormatListBulletedOutlined}
                navigateTo={"/worker/schedule"}
                cardProps={{style:{marginBottom: 24}}}
            />
        </div>
    )
}
